import type { Option } from '@openx/types/options';
import type { FilterCriteria } from '../../types';

export const getInitialMultiSelectWithRadioValues = (options?: Option[], appliedFilters?: FilterCriteria) => {
  return (
    options?.reduce<Record<string, boolean>>((acc, option) => {
      acc[option.id] = appliedFilters?.[option.id] !== undefined;
      return acc;
    }, {}) || {}
  );
};
